export const logo = require("../images/signup/logo-image.webp")
export const shield = require("../images/signup/signup-shieldimage.webp")
export const shield2 = require("../images/signup/signup-shieldimage2.webp")

//dev
export const API_URL = "https://api.corsia.shop/api/";
// export const API_URL = "https://www.corsia.shop/api/";

export const SERVER_DOMAIN = "https://api.corsia.shop/";
// export const SERVER_DOMAIN = "https://www.corsia.shop/";
// export const SOCKET_DOMAIN = "http://localhost:5000"

//Production
// export const END_POINT = "https://api.iboostmd.com/api/";
// export const SOCKET_DOMAIN = "https://api.iboostmd.com"

export const ENVIRONMENT = "dev"
export const metaTitle = "Corsia | ";

export default {
    logo,
    shield,
    shield2,
    API_URL,
    // SOCKET_DOMAIN,
    ENVIRONMENT,
    metaTitle,
    SERVER_DOMAIN
}


